<script>
import cloneDeep from 'lodash/cloneDeep'
import render from '@/views/form/components/render/render.js'
import { ruleSelectList } from '@/views/form/components/generator/config'
import { hasChangedLogColumns } from '@/api/form'
import { compDefaultValue } from '@/views/form/components/generator/config'
import projectCombination from '@/components/projectId/combination.vue'
const ruleTrigger = {
  'el-input': 'blur',
  'el-input-number': ['blur', 'change'],
  'el-select': 'change',
  'el-radio-group': 'change',
  'el-checkbox-group': 'change',
  'el-cascader': 'change',
  'el-time-picker': 'change',
  'el-date-picker': 'change',
  'el-rate': 'change',
  'el-upload': 'change'
}

const layouts = {
  colFormItem(h, scheme) {
    const config = scheme.bpmConfig
    const compType = scheme.compType
    const listeners = buildListeners.call(this, scheme)
    let labelWidth = config.labelWidth ? `${config.labelWidth}px` : null
    if (config.showLabel === false) labelWidth = '0'
    // const noSelect = scheme.compType !== 14 && scheme.compType !== 15 && this.isText && !scheme.isEditText ? 'bpm-no-actions' : ''
    // if (compType === 2) {
    //   className = 'multiLineText'
    // } else {
    //   className = ''
    // }
    const cols = compType === 2 ? 'multiLineText' : ''
    const myText = compType === 21 ? 'myText' : ''
    const arr = [cols, myText]
    const hideEditCompTypeList = [21, 22, 23, 26] // 需隐藏编辑记录的
    // eslint-disable-next-line eqeqeq
    const hideEdit = hideEditCompTypeList.includes(scheme.compType)
    if (this.isText) {
      return (
        !scheme.hiddenFormItem && (!config.conditionList || (config.conditionList && config.conditionList.length === 0) || this.showFormItem(scheme)) ? (<el-col span={config.span}>
          <el-form-item
            prop={scheme.vModel}
            label-width={labelWidth}
            class={arr.join(' ')}
            key={scheme.vModel}
            label={config.showLabel ? config.label : ''}>
            <p slot='label' class='bpm-form-label'>
              <span>{config.showLabel ? config.label : ''}</span>
              {this.editFieldList.includes(scheme.vModel) && !hideEdit ? <span onClick={() => this.openEditDrawer(scheme.vModel, scheme)} class='edit-history'><svg-icon icon-class='edit-record'/>编辑记录</span> : null}
            </p>
            <keep-alive>
              {
                (scheme?.compType === 4 || scheme?.compType === 5) && scheme?.bpmConfig?.optionType === 1 && scheme?.bpmConfig?.statisticsTmpId === '1742922669609455618'
                  ? <project-combination v-model={this[this.formConf.formModel][scheme.vModel]} fields={scheme} isText={this.isText && !scheme.isEditText} isPrint={this.isPrint}/>
                  : <render processId={this.processId} formData={this[this.formConf.formModel]} systemInfo={this.systemInfo} isPrint={this.isPrint} isText={this.isText && !scheme.isEditText} isParse={true} conf={scheme} on={listeners} />
              }
            </keep-alive>
          </el-form-item>
        </el-col>) : null
      )
    } else {
      return (
        !scheme.hiddenFormItem && (!config.conditionList || (config.conditionList && config.conditionList.length === 0) || this.showFormItem(scheme)) ? (<el-col span={config.span}>
          <el-form-item key={scheme.vModel} label-width={labelWidth} prop={scheme.vModel}
            label={config.showLabel ? config.label : ''} class={compType === 21 ? 'myText' : ''}>
            <p slot='label' class='bpm-form-label'>
              <span>{config.showLabel ? config.label : ''}</span>
              {this.editFieldList.includes(scheme.vModel) && !hideEdit ? <span onClick={() => this.openEditDrawer(scheme.vModel, scheme)} class='edit-history'><svg-icon icon-class='edit-record'/>编辑记录</span> : null}
            </p>
            <keep-alive>
              {
                (scheme?.compType === 4 || scheme?.compType === 5) && scheme?.bpmConfig?.optionType === 1 && scheme?.bpmConfig?.statisticsTmpId === '1742922669609455618'
                  ? <project-combination v-model={this[this.formConf.formModel][scheme.vModel]} fields={scheme}/>
                  : <render processId={this.processId} formData={this[this.formConf.formModel]} systemInfo={this.systemInfo} isPrint={this.isPrint} isText={this.isText} isParse={true} conf={scheme} on={listeners} />
              }
            </keep-alive>

          </el-form-item>
        </el-col>) : null
      )
    }
  },
  rowFormItem(h, scheme) {
    const listeners = buildListeners.call(this, scheme)
    const config = scheme.bpmConfig
    let labelWidth = config.labelWidth ? `${config.labelWidth}px` : null
    if (config.showLabel === false) labelWidth = '0'
    if (scheme.compType === 25) {
      return (!scheme.hiddenFormItem && (!config.conditionList || (config.conditionList && config.conditionList.length === 0) || this.showFormItem(scheme)) ? (<el-col span={config.span}>
        <el-form-item key={scheme.vModel} label-width={labelWidth} prop={scheme.vModel}
          label={config.showLabel ? config.label : ''}>
          <p slot='label' class='bpm-form-label'>
            <span>{config.showLabel ? config.label : ''}</span>
            {this.editFieldList.includes(scheme.vModel) ? <span onClick={() => this.openEditDrawer(scheme.vModel, scheme)} class='edit-history'><svg-icon icon-class='edit-record'/>编辑记录</span> : null}
          </p>
          <keep-alive>
            {
              (scheme?.compType === 4 || scheme?.compType === 5) && scheme?.bpmConfig?.optionType === 1 && scheme?.bpmConfig?.statisticsTmpId === '1742922669609455618'
                ? <project-combination v-model={this[this.formConf.formModel][scheme.vModel]} fields={scheme}/>
                : <render processId={this.processId} formData={this[this.formConf.formModel]} systemInfo={this.systemInfo} children={scheme.bpmConfig && scheme.bpmConfig.children || []} isPrint={this.isPrint} isText={this.isText} isParse={true} conf={scheme} on={listeners} />
            }
          </keep-alive>
        </el-form-item>
      </el-col>) : null)
    } else {
      let child = renderChildren.apply(this, arguments)
      if (scheme.type === 'flex') {
        child = <el-row type={scheme.type} justify={scheme.justify} align={scheme.align}>
          {child}
        </el-row>
      }
      return (
        <el-col span={scheme.span}>
          <el-row gutter={scheme.gutter}>
            {child}
          </el-row>
        </el-col>
      )
    }
  }
}

function renderFrom(h) {
  const { formConfCopy } = this

  return (
    <el-row class={{ 'bpm-form-parser': true, 'bpm-is-print': this.isPrint }} gutter={0}>
      <el-form
        size={formConfCopy.size}
        label-position={formConfCopy.labelPosition}
        disabled={formConfCopy.disabled}
        label-width={`${formConfCopy.labelWidth}px`}
        ref={formConfCopy.formRef}
        validate-on-rule-change={false}
        // labelSuffix={this.isText ? ':' : ''}
        // model不能直接赋值 https://github.com/vuejs/jsx/issues/49#issuecomment-472013664
        props={{ model: this[formConfCopy.formModel] }}
        rules={this[formConfCopy.formRules]}
      >
        {renderFormItem.call(this, h, formConfCopy.fields)}
      </el-form>
      <form-edit-drawer systemInfo={this.systemInfo} ref='editDrawer' />
    </el-row>
  )
}
// {formConfCopy.formBtns && formBtns.call(this, h)}
// function formBtns(h) {
//   return <el-col>
//     <el-form-item size='large' style={{ 'display': 'flex', 'justify-content': 'center' }}>
//       <el-button type='primary' size='small' onClick={this.submitForm}>提交</el-button>
//       <el-button size='small' onClick={this.resetForm}>重置</el-button>
//     </el-form-item>
//   </el-col>
// }

function renderFormItem(h, elementList) {
  return elementList.map(scheme => {
    const config = scheme.bpmConfig
    const layout = layouts[config && config.layout]

    if (layout) {
      // if (elementList.span === 0) {
      //  return  <el-col style='height:0px' span={24} />
      // }
      return layout.call(this, h, scheme)
    }
    if (scheme.type === 'empty') {
      return <el-col spam={24}></el-col>
    }
    throw new Error(`没有与${config && config.layout}匹配的layout`)
  })
}

function renderChildren(h, scheme) {
  const config = scheme.bpmConfig
  if (!Array.isArray(config.children)) return null
  return renderFormItem.call(this, h, config.children)
}

function setValue(event, config, scheme) {
  this.$set(config, 'defaultValue', event)
  this.$set(this[this.formConf.formModel], scheme.vModel, event)
}

function buildListeners(scheme) {
  const config = scheme.bpmConfig
  const methods = this.formConf.__methods__ || {}
  const listeners = {}

  // 给__methods__中的方法绑定this和event
  Object.keys(methods).forEach(key => {
    listeners[key] = event => methods[key].call(this, event)
  })
  // 响应 render.js 中的 vModel $emit('input', val)
  listeners.input = event => setValue.call(this, event, config, scheme)

  return listeners
}
export default {
  componentName: 'ParserGeneratorForm',
  components: {
    render,
    formEditDrawer: () => import('@/views/taskManage/components/editHistory/index.vue'),
    projectCombination
  },
  props: {
    formConf: {
      type: Object,
      required: true
    },
    isPrint: {
      type: Boolean,
      default: false
    },
    isText: {
      type: Boolean,
      default: false // 是否禁止编辑
    },
    userId: {
      type: String,
      default: ''
    },
    processId: {
      type: String,
      default: ''
    },
    systemInfo: { // 系统变量
      type: Object,
      default: () => {}
    }
    // saveType: {
    //   type: Number,
    //   default: 1
    // }
  },
  data() {
    const data = {
      imgUrl: '',
      dialogVisible: false,
      dialogImageUrl: '',
      formConfCopy: cloneDeep(this.formConf),
      // 子组件抛出数据
      [this.formConf.formModel]: {},
      [this.formConf.formRules]: {},
      editFieldList: [] // 存在编辑字段的数据
    }
    this.initFieldsCol(data.formConfCopy.fields)
    this.initFormData(data.formConfCopy.fields, data[this.formConf.formModel])
    this.buildRules(data.formConfCopy.fields, data[this.formConf.formRules])
    return data
  },
  watch: {
    saveType: {
      handler: function(newval, oldval) {
        if (newval === 2) {
          console.log('saveType', newval)
          this.$refs[this.formConf.formRef].clearValidate()
        }
      },
      immediate: true
    },
    // 查询编辑记录
    processId: {
      handler(val) {
        this.getChangeLogList()
      }
    }
  },
  mounted() {
    this.getChangeLogList()
  },
  created() {
    console.log(this.isPrint, this.isText)
    // 项目编号先清除数据
    this.$store.state.app.projectIdValidates = []
  },
  methods: {
    // 获取编辑字段列表
    async getChangeLogList() {
      if (!this.processId) {
        this.editFieldList = []
        return
      }
      const res = await hasChangedLogColumns({
        processInstanceId: this.processId
      })
      if (res.code === 200 && res.data) {
        this.editFieldList = res.data || []
      }
    },
    // 打开字段编辑
    openEditDrawer(filed, conf) {
      this.$refs.editDrawer.openDrawer(this.processId, filed, conf)
    },
    // 处理组件高度不同换行问题
    initFieldsCol(fields) {
      const deal = (arr) => {
        let col = 0
        // let length = arr.length - 1
        for (let index = 0; index < arr.length; index++) {
          const item = arr[index]
          if (item.bpmConfig && item.bpmConfig.layout === 'colFormItem') {
            item.span = col + item.bpmConfig.span
            if (item.span > 24) {
              console.log('item.span', item.span)
              // length = length + 1
              arr.splice(index, 0, { type: 'empty' })
              item.span = 0
              col = 0
            }
            col = item.span
          } else if (item.bpmConfig && item.bpmConfig.layout === 'rowFormItem') {
            // 重新设置换行
            item.span = col + item.bpmConfig.span
            if (item.span > 24) {
              console.log('item.span', item.span)
              // length = length + 1
              arr.splice(index, 0, { type: 'empty' })
              item.span = 0
              col = 0
            }
            if (item.bpmConfig && item.bpmConfig.children && item.bpmConfig.children.length > 0) {
              deal(item.bpmConfig.children)
            }
            // 重新设置换行
            col = item.span
          }
        }
      }
      deal(fields)
    },
    initFormData(componentList, formData) {
      componentList.forEach(cur => {
        const config = cur.bpmConfig
        if (cur.vModel) formData[cur.vModel] = config.defaultValue
        if (config && config.children && cur.compType !== 25) this.initFormData(config.children, formData)
      })
    },
    buildRules(componentList, rules) {
      componentList.forEach(cur => {
        const config = cur.bpmConfig
        if (cur.type !== 'empty' && config && config.regList && Array.isArray(config.regList)) {
          if (cur.compType && cur.compType !== 25) {
            if (config.required) {
              const required = { required: config.required, message: cur.placeholder }
              if (Array.isArray(config.defaultValue)) {
                required.type = 'array'
                required.message = `请至少选择一个${config.label}`
              }
              required.message === undefined && (required.message = `${config.label}不能为空`)
              config.regList.push(required)
            }
            if (cur.bpmConfig && cur.bpmConfig.regExp) {
              const patternItem = ruleSelectList.findIndex((item) => item.value === cur.bpmConfig.regExp)
              if (patternItem !== -1) {
                config.regList.push({
                  pattern: ruleSelectList[patternItem].reg,
                  message: '请输入' + ruleSelectList[patternItem].label
                })
              }
            }
            rules[cur.vModel] = config.regList.map(item => {
            // eslint-disable-next-line no-eval
              item.pattern && (item.pattern = eval(item.pattern))
              item.trigger = ruleTrigger && ruleTrigger[config.tag] || 'none'
              return item
            })
          } else {
            if (cur.type !== 'empty') {
              const patternList = []
              console.log('config.children', config.children)
              if (config.children && config.children.length > 0) {
                config.children.forEach((item) => {
                  console.log('item', item)
                  if (item && item.type !== 'empty' && item.bpmConfig.regList && Array.isArray(item.bpmConfig.regList)) {
                    if (item.bpmConfig.required) {
                      patternList.push({ name: item.vModel, required: true, trigger: 'none' })
                    }
                    if (item.bpmConfig && item.bpmConfig.regExp) {
                      const patternItem = ruleSelectList.findIndex((item2) => item2.value === item.bpmConfig.regExp)
                      if (patternItem !== -1) {
                        patternList.push({
                          name: item.vModel,
                          pattern: ruleSelectList[patternItem].reg,
                          message: '请输入' + ruleSelectList[patternItem].label,
                          trigger: 'none'
                        })
                      }
                    }
                  }
                })
              }
              const rueList = []
              if (config.required) {
                rueList.push({ required: true, message: config.actionName || '请添加明细', trigger: 'none' })
              }
              if (patternList.length > 0) {
                rueList.push({
                  trigger: 'none',
                  validator: (rule, value, callback) => {
                    let res = true
                    let message = ''
                    for (let i = 0; i < patternList.length; i++) {
                      const item = patternList[i]
                      const name = item.name
                      const confList = config.children || []
                      const nameOptions = confList.find((item) => item.vModel === name)
                      const nameMessage = nameOptions && nameOptions.bpmConfig && nameOptions.bpmConfig.label + '内容不能为空' || ''
                      // 必填校验
                      if (item.required) {
                        if (name === 'form') {
                          if (value.length === 0) {
                            res = false
                            message = item.message
                            break
                          }
                        } else {
                          for (let j = 0; j < value.length; j++) {
                            if ((!value[j][name] && value[j][name] !== 0) || (Array.isArray(value[j][name]) && value[j][name].length === 0)) {
                              const nameOptions = confList.find((item) => item.vModel === name)
                              if (nameOptions) {
                                message = nameMessage
                              }
                              res = false
                              break
                            }
                          }
                        }
                        if (!res) {
                          break
                        }
                      } else if (item.pattern) {
                        // eslint-disable-next-line no-eval
                        const evalPattren = eval(item.pattern)
                        for (let k = 0; k < value.length; k++) {
                          console.log('value[k]', value[k])
                          if (value[k] && !evalPattren.test(value[k][name])) {
                            console.log('value[k][name]', value[k][name])
                            res = false
                            message = nameMessage
                            console.log('nameMessage', nameMessage || '--')
                            break
                          }
                        }
                        if (!res) {
                          break
                        }
                      }
                    }
                    if (!res) {
                      console.log('进入了报错', message)
                      return callback(new Error(message))
                    }
                    return callback()
                  }
                })
              }
              rules[cur.vModel] = rueList
            }
          }
        }
        if (cur.compType !== 25) {
          if (config && config.children) this.buildRules(config.children, rules)
        }
      })
    },
    // 用于上传等高级组件选择后重新触发校验
    validGeneratorForm(field) {
      this.$refs[this.formConf.formRef].validateField(field)
    },
    resetForm() {
      this.formConfCopy = cloneDeep(this.formConf)
      this.$refs[this.formConf.formRef].resetFields()
    },
    async submitForm(saveType) {
      this.saveType = saveType
      // saveType 1:提交 2:暂存（暂存不需要校验必填项）
      console.log('this.formConf', this.formConf, saveType)
      if (saveType === 2) {
        this.buildRules(this.formConfCopy.fields, [])
        const cloneData = cloneDeep(this[this.formConf.formModel])
        Object.keys(cloneData).forEach((item) => {
          if (cloneData[item] && Array.isArray(cloneData[item]) && cloneData[item][0] && cloneData[item][0].confList) {
            console.log('')
            cloneData[item].forEach((formArr) => {
              console.log('formArr', formArr)
              delete formArr.confList
            })
          }
        })
        this.$emit('submit', cloneData)
        return true
      } else {
        // 项目编号的验证
        const projectIdValidate = await this.projectIdValidate()
        if (!projectIdValidate) {
          this.$nextTick(() => {
            if (document.querySelector('.el-form-item.is-error')) {
              document.querySelector('.el-form-item.is-error').scrollIntoView({
                block: 'center',
                behavior: 'smooth'
              })
            }
          })
          return false
        }

        this.$refs[this.formConf.formRef].validate(valid => {
          if (!valid) {
            this.$nextTick(() => {
              if (document.querySelector('.el-form-item__error')) {
                document.querySelector('.el-form-item__error').scrollIntoView({
                  block: 'center',
                  behavior: 'smooth'
                })
              }
            })
            return false
          }

          // 触发sumit事件\
          // console.log('this.formConf', this.formConfCopy)
          // console.log('this.formConf.formModel', this[this.formConf.formModel])
          const cloneData = cloneDeep(this[this.formConf.formModel])
          Object.keys(cloneData).forEach((item) => {
            if (cloneData[item] && Array.isArray(cloneData[item]) && cloneData[item][0] && cloneData[item][0].confList) {
              console.log('')
              cloneData[item].forEach((formArr) => {
                delete formArr.confList
              })
            }
          })
          this.$emit('submit', cloneData)
          return true
        })
      }
    },
    projectIdValidate() {
      return new Promise((resolve, reject) => {
        // 收集的是validate函数，执行后，会返回Promise对象，然后在Promise.all，统一释放这些Promise对象， 最后同步返回结果，进行下一步
        const projectIdValidates = this.$store.state.app.projectIdValidates
        const r = []
        for (let i = 0; i < projectIdValidates.length; i++) {
          if (typeof projectIdValidates[i] === 'function') {
            const obj = projectIdValidates[i]()
            r.push(obj)
          }
        }
        Promise.all(r).then((values) => {
          resolve(true)
        }).catch(() => {
          resolve(false)
        })
      })
    },
    submitValidate() {
      return new Promise((resolve) => {
        this.$refs[this.formConf.formRef].validate(valid => {
          console.log('valid', valid)
          if (!valid) resolve(false)
          // 触发sumit事件\
          // console.log('this.formConf', this.formConfCopy)
          // console.log('this.formConf.formModel', this[this.formConf.formModel])
          resolve(this[this.formConf.formModel])
        })
      })
    },
    showFormItem(conf) {
      const formData = this[this.formConf.formModel]
      const cloneConf = conf
      const vModel = cloneConf.vModel
      const compType = cloneConf.compType
      console.log('vModel', vModel)
      console.log('compType', compType)
      let show = false
      const conditionList = cloneConf.bpmConfig && cloneConf.bpmConfig.conditionList || []
      if (conditionList.length === 0) {
        show = true
        return show
      } else {
        const cloneCondition = cloneDeep(conditionList)
        cloneCondition.forEach((item) => {
          if (Array.isArray(item) && item.length > 0) {
            item.forEach((conditionItem) => {
              // 输入了数据
              const isRealData = !!(formData[conditionItem.vModel] || formData[conditionItem.vModel] === 0)
              let NumberItem
              try {
                NumberItem = Number(formData[conditionItem.vModel])
              } catch (err) {
                NumberItem = 0
              }
              let conditionValue
              try {
                conditionValue = Number(conditionItem.value)
              } catch (err) {
                NumberItem = 0
              }
              switch (conditionItem.condition) {
                case 1:
                  conditionItem.isMatch = formData[conditionItem.vModel] && formData[conditionItem.vModel].includes(conditionItem.value)
                  break
                case 2:
                  conditionItem.isMatch = !(formData[conditionItem.vModel] && formData[conditionItem.vModel].includes(conditionItem.value))
                  break
                case 3:
                  conditionItem.isMatch = isRealData && NumberItem === conditionValue
                  break
                case 4:
                  conditionItem.isMatch = isRealData && NumberItem > conditionValue
                  break
                case 5:
                  conditionItem.isMatch = isRealData && NumberItem >= conditionValue
                  break
                case 6:
                  conditionItem.isMatch = isRealData && NumberItem < conditionValue
                  break
                case 7:
                  conditionItem.isMatch = isRealData && NumberItem <= conditionValue
                  break
                case 8:
                  conditionItem.isMatch = isRealData && NumberItem !== conditionValue
                  break
                case 9:
                  conditionItem.isMatch = !isRealData
                  break
                case 10:
                  conditionItem.isMatch = isRealData
                  break
                case 11:
                  conditionItem.isMatch = formData[conditionItem.vModel] && String(formData[conditionItem.vModel]).includes(conditionItem.value)
                  break
                default:
                  conditionItem.isMatch = false
              }
            })
          }
        })
        let show = false
        cloneCondition.forEach((dealItem) => {
          const matchItemList = dealItem.filter((item) => item.isMatch)
          if (matchItemList.length === dealItem.length) {
            show = true
          }
        })
        if (show === false) {
          formData[vModel] = compDefaultValue[compType] || undefined
          conf.bpmConfig.defaultValue = compDefaultValue[compType] || undefined
        }
        console.log('show', show)
        return show
      }
    }
  },
  render(h) {
    return this.formConf.formModel ? renderFrom.call(this, h) : null
  }
}
</script>

<style lang="scss" scoped>
  .bpm-form-parser {
    padding: 0px 10px;
    /deep/.el-row {
      position: initial;
    }
    .bpm-form-label {
      display: inline-block;
    }
    /deep/.el-form-item {
      margin-bottom: 22px !important;
      padding-right: 10px;
      .el-rate {
        height: auto;
        display: inline-block;
        vertical-align: text-top;
      }
      .edit-history {
        color: #165DFF;
        font-size: 12px;
        cursor: pointer;
        margin-left: 10px;
        svg {
          margin-right: 2px;
        }
      }
      .el-upload-list__item {
        transition: none;
      }
      .el-col {
        padding-right: 10px;
      }
      .el-input-number {
        width: 100%;
        input {
          text-align: left;
        }
      }
      // .el-radio {
      //   margin-bottom: 14px;
      // }
      &.el-form-item--medium {
        .el-radio {
          line-height: 38px;
        }
      }
      &.el-form-item--small {
        .el-radio {
          line-height: 32px;
        }
      }
      &.el-form-item--mini {
        .el-radio {
          line-height: 29px;
        }
      }
    }
    .bpm-no-actions {
      pointer-events: none;
    }
    /deep/.el-form-item.multiLineText{
      .el-form-item__content{
        overflow-wrap: break-word;
        max-height:150px;
        overflow-y: auto;
      }
    }
    /deep/.el-form-item.myText{
      white-space: pre-line;
      margin-bottom: 0 !important;
      word-break: break-all;
    }
    /deep/.textarea-print {
      background-color: #F5F7FA;
      border-color: #dfe4ed;
      color: #C0C4CC;
      cursor: not-allowed;
      padding: 4px 15px;
      border-radius: 4px;
      border: 1px solid #DCDFE6;
      line-height: 24px;
      white-space: pre-line
    }
    /deep/.flow-upload-show {
      .el-upload--picture-card {
        display: none;
      }
      .el-upload-list__item-status-label {
        display: none!important;
      }
      .el-upload__tip {
        display: none;
      }
    }
    &.bpm-is-print {
      /deep/.el-radio {
        .el-radio__inner {
          position: relative;
          &::after {
            transform: none;
            left: 4px;
            top: 4px;
          }
        }
      }
    }
  }
</style>
